<template>
    <section class="category-header">
        <div class="container-fluid">
            <div class="category-title">
                <h1>{{ description ? description.header : 'Каталог' }}</h1>
                <span v-if="pagination.total && isReady">{{ totalCount }}</span>
            </div>
            <div class="category-filters category-filters--mobile">
                <q-btn class="filter-categories" outline @click.prevent="openDialogCategoriesMobile()"
                       style="margin-right: 10px;">Категории</q-btn>
                <q-btn class="filter-options" outline
                   @click.prevent="openDialogFiltersMobile()"><span v-if="totalSelected" class="badge">{{ totalSelected }}</span>Фильтры</q-btn>
            </div>
        </div>
        <modal-categories></modal-categories>
        <modal-filters classes="filter-model"></modal-filters>
    </section>
</template>

<script>
import {mapState, mapGetters, mapMutations} from 'vuex';
import Categories from "./Categories";
import FilterItem from "./../../Catalog/Filter/Item"
import ModalCategories from "./../../Catalog/Modals/Categories"
import ModalFilters from "./../../Catalog/Modals/Filters"

export default {
    name: 'CatalogFilters',
    components: {
        Categories,
        FilterItem,
        ModalCategories,
        ModalFilters,
    },
    data() {
        return {
            showSort: false,
            isSliderChanged: false,
            isExpanded: false,
            totalSelected: 0,
        }
    },
    mounted() {
        let _this = this;
        _this.totalSelected = _this.allSelectedCount();

        document.addEventListener('click', (e) => {
            if (!e.target.classList.contains('dropdown-toggle')) {
                _this.showSort = false;
            }
        });
        this.isExpanded = _.filter(this.filterList, filter => !filter.show_by_default).length === 0;
    },
    watch: {
        active(active) {
            if (active && window.width() > 991) {
                document.addEventListener('click', this.clickOutsideOfFilter);
            }
        },
        isReady(value) {
            if (value) {
                this.totalSelected = this.allSelectedCount();
            }
        },
        dialogCategoriesMobile(value) {
            if (value) {
                this.setActive('category')
            }
        }
    },
    computed: {
        ...mapState('catalog', [
            'pagination',
            'selected',
            'description',
            'categoryId',
            'filterList',
            'active',
            'dialogCategoriesMobile',
        ]),
        ...mapGetters('catalog', [
            'isReady',
            'changed',
            'filterValues',
            'isSlider',
        ]),
        totalCount () {
            let total = this.pagination.total;

            let digits = total.toString().split('');

            let lastDigit = parseInt(digits.pop());
            let beforeTheLastOneDigit = parseInt(digits.pop());

            if (lastDigit === 1 && ((total < 10) || (beforeTheLastOneDigit !== 1))) {
                return `${total} модель`;
            }

            if ([2, 3, 4].includes(lastDigit) && ((total < 10) || (beforeTheLastOneDigit !== 1))) {
                return `${total} модели`;
            }

            return `${total} моделей`;
        }
    },
    methods: {
        ...mapMutations('catalog', [
            'setActive',
            'toggleDialogCategoriesMobile',
            'toggleDialogFiltersMobile'
        ]),
        openDialogFiltersMobile() {
            this.toggleDialogFiltersMobile(true)
        },
        openDialogCategoriesMobile() {
            this.toggleDialogCategoriesMobile(true)
        },
        clickOutsideOfFilter(event) {
            if (!this.isSliderChanged
                && !event.target.closest('.filter')
                && !event.target.classList.contains('filter-apply')
            ) {
                this.setActive(null)
            }
            this.isSliderChanged = false;
        },
        selectedCount(filter) {
            if (this.selected[filter] && !['dir', 'code', 'page'].includes(filter)) {
                return this.isSlider(filter) || filter === 'sort'
                    ? 1
                    : this.selected[filter].length;
            }
            return 0;
        },
        allSelectedCount() {
            let count = 0;

            for (let prop in this.selected) {
                if (prop !== 'category') {
                    count += this.selectedCount(prop);
                }
            }
            return count;
        },
    }
}
</script>

